import HammerSlide from "./../hammerSlide";

import ImageGallerySlide from "./../../../../common/components/imageGallerySlide";

import {
  ZOOM_IN_IMAGE_GALLERY,
  ZOOM_OUT_IMAGE_GALLERY,
  PAN_ZOOMEDINIMAGE_GALLERY,
} from "./../../../../common/analytics/analyticsevents";

export default class ImageGallerySlideMobile extends ImageGallerySlide {
  hammerSlide = null;

  isZoomed() {
    if (!this.hammerSlide) {
      return false;
    }
    return this.hammerSlide.isZoomed();
  }

  allowSwiping(e) {
    return this.hammerSlide.allowSwiping(e);
  }

  panning(e) {
    this.hammerSlide.panning(e);
  }

  panningEnd(e) {
    this.hammerSlide.panningEnd(e);
  }

  onPinch(e) {
    this.hammerSlide.onPinch(e);
  }

  onPinchEnd(e) {
    this.hammerSlide.onPinchEnd(e);
  }

  onPinchStart(e) {
    this.hammerSlide.onPinchStart(e);
  }

  initHammerSlide(ratio) {
    this.ratio = ratio;
    this.createHammerSlide(false);
  }

  setUrl(container) {
    if (container) {
      container.setAttribute("src", container.dataset.img);
    }
  }

  //call only after image is loaded
  createHammerSlide(isResized) {
    if (!this.hammerSlide && (!this.takeResized || isResized)) {
      const options = this.options.hammerslide;
      this.hammerSlide = new HammerSlide(
        this.DOMContainer,
        this.DOMContainer.querySelector(".slide-imageviewer-container"),
        false,
        options,
        this.ratio
      );
      this.hammerSlide.on("hammerSlide:notZoomed", () => {
        this.notZoomed();
      });
      this.hammerSlide.on("hammerSlide:zoomed", () => {
        this.zoomed();
      });
      this.hammerSlide.on("hammerSlide:zoominend", () => {
        this.appState.triggerEvent(ZOOM_IN_IMAGE_GALLERY);
      });
      this.hammerSlide.on("hammerSlide:zoomoutend", () => {
        this.appState.triggerEvent(ZOOM_OUT_IMAGE_GALLERY);
      });
      this.hammerSlide.on("hammerSlide:panend", () => {
        this.appState.triggerEvent(PAN_ZOOMEDINIMAGE_GALLERY);
      });
      this.hammerSlide.init();
    }
  }

  resize(height, keepScale) {
    if (this.hammerSlide) {
      this.hammerSlide.resize(height, keepScale);
    } else {
      const img = this.DOMContainer.querySelector(".slide-imageviewer.non-hd");
      this.takeResized = true;
      $(img).on("load", () => {
        //if called directly ratio is NAN because img is not laoded yet and has width of zero
        this.createHammerSlide(true);
      });
    }
  }

  zoomed() {
    this.hideCaption();
    this.trigger("imageViewerSlide:zoomed");
  }

  notZoomed() {
    this.showCaption();
    this.trigger("imageViewerSlide:notZoomed");
  }

  hideCaption() {
    if (this.caption) {
      this.caption.classList.add("hidden");
    }
  }

  showCaption() {
    if (this.caption) {
      this.caption.classList.remove("hidden");
    }
  }
}



// WEBPACK FOOTER //
// ./src/touch/reader/components/imageGallery/imageGallerySlideMobile.js